import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Loading } from "@/components/Loading";

export const AdminJobs = () => {
  const [rows, setRows] = useState(null);
  const [status, setStatus] = useState("failed");
  const load = useCallback(() => api.get("/admin/jobs", { params: status ? { status } : {} }).then(({ data }) => setRows(data)), [status]);
  useEffect(() => { load(); }, [load]);
  const retry = async (id) => {
    try { await api.post(`/admin/jobs/${id}/retry`); toast.success("Job queued again"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!rows) return <Loading />;
  return (
    <div data-testid="admin-jobs">
      <select className="field mb-5 !w-auto" value={status} onChange={(e) => setStatus(e.target.value)} data-testid="admin-jobs-filter">
        <option value="failed">Failed</option><option value="">All</option><option value="queued">Queued</option><option value="running">Running</option><option value="succeeded">Succeeded</option>
      </select>
      <div className="overflow-x-auto paper-card">
        <table className="w-full text-left text-base">
          <thead className="bg-[#F2EBE1]"><tr>{["Updated", "Order", "Job", "Status", "Attempts", "Error", ""].map((h) => <th key={h} className="px-3 py-3">{h}</th>)}</tr></thead>
          <tbody>
            {rows.map((j) => (
              <tr key={j.job_id} className="border-t border-[#E6DEC6]" data-testid={`admin-job-row-${j.job_id}`}>
                <td className="px-3 py-3 text-sm">{new Date(j.updated_at).toLocaleString()}</td>
                <td className="px-3 py-3 text-sm">{j.order_id}</td>
                <td className="px-3 py-3">{j.label}</td>
                <td className="px-3 py-3 font-semibold">{j.status} {j.status === "running" && `${j.progress}%`}</td>
                <td className="px-3 py-3">{j.attempts}</td>
                <td className="max-w-xs px-3 py-3 text-sm text-[#991B1B]">{j.error}</td>
                <td className="px-3 py-3">{j.status === "failed" && <button className="btn-outline !min-h-0 !py-1" onClick={() => retry(j.job_id)} data-testid={`admin-job-retry-${j.job_id}`}>Retry</button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {!rows.length && <p className="p-6 text-[#5C4A3E]" data-testid="admin-jobs-empty">No jobs here.</p>}
      </div>
    </div>
  );
};
